import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=58202906&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=ts"
export * from "./UploadFile.vue?vue&type=script&lang=ts"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=58202906&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58202906",
  null
  
)

export default component.exports